<!--
 * @Author: linrui
 * @Date: 2021-12-28 20:39:12
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-09 16:06:24
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/understandingText.vue
-->
<template>
    <div class="understanding-text-wrapper">
        <div class="understanding-text-box" ref="understandingTextBox">
            <!-- <p class="understanding-title" ref="understandingTitle">医生项目备案</p> -->
            <p v-html="understandingText" class="understanding-text" ref="understandingText" style="font-size:14px;line-height:23px"></p>
        </div>
        <!-- S 底部提交栏 -->
        <div class="page-ft">
            <div class="doc-agree">
                <van-checkbox v-model="hasAgreed" checked-color="#2aa8b1" @click="handleCheckboxClick">我已经仔细阅读并同意成为“择美同行-患者援助项目”的项目医生，并遵循项目规定。</van-checkbox>
                <!-- <p class="tips">我申请成为中国初级卫生保健基金会择美同行项目的项目医生</p> -->
            </div>
            <div class="btn">
                <van-button class="up" v-if="second > 0" type="primary" disabled>
                    确认<template v-if="second>-1">（{{second}}秒）</template>
                </van-button>
                <van-button class="up" v-else type="primary" @click.native="confirmUnderstading">
                    确认<template v-if="second>-1">（{{second}}秒）</template>
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetMemo,
    DoctorReadRecord
} from '../../api/api'
import {mapState} from 'vuex'
export default {
    data() {
        return {
            second: 5,
            hasAgreed:false,//是否已经同意
            isClickable:false,//是否能点击checkbox
            understandingText:'',
            understandingTextHeight:'',//box高度
            finalHeight:'',//最终达到的高度
            isTimeOut:false,
            timer:null,
            submitBtnDisabled:false,//是否禁用按钮
        }
    },
    computed:{
        ...mapState({
            doctorInfo:state => state.doctor.doctorInfo
        })
    },
    async created() {
        let res = await GetMemo()
        this.understandingText = res.data.value.replace(/{name}/, this.doctorInfo.name)
        console.log(this.doctorInfo,'doctorInfo');
    },
    mounted() {
        let that = this
        // this.$refs.understandingTextBox.addEventListener('scroll',function() {
        //     console.log('安卓手机addEventListener不响应')
        //     that.understandingTextHeight = that.$refs.understandingTextBox.scrollTop
        //     console.log(that.understandingTextHeight,'that.understandingTextHeight')
        //     that.finalHeight = that.$refs.understandingText.clientHeight - that.$refs.understandingTextBox.clientHeight
        //     console.log(that.finalHeight,'that.finalHeight')
        // })
        this.timer = setInterval(() => {
            this.second--;
            if (this.second < 0) {
                clearInterval(this.timer);
                that.isTimeOut = true
            }
        },1000)
    },
    methods:{
        handleCheckboxClick() {
            if(this.isTimeOut) {
                return
            } else {
                this.hasAgreed = false
                this.$toast('请阅读完医生理解备忘录后再进行勾选')
            }
        },
        confirmUnderstading() {
            if(!this.hasAgreed) {
                this.$toast('请阅读完医生理解备忘录后再进行勾选')
                return
            }
            this.submitBtnDisabled = true
            DoctorReadRecord(this.doctorInfo.id).then( () => {
                this.submitBtnDisabled = false
                this.$router.replace({
                    name:'RecordTable'
                })
            }).catch( err => {
                this.submitBtnDisabled = false
                this.$toast(err.response.data.message)
            })
        }
    },
    // watch:{
    //     understandingTextHeight(newVal) {
    //         if(newVal && (this.finalHeight - newVal) >= 0 && (this.finalHeight - newVal) <= 2 ) {
    //             this.isClickable = true
    //             this.timer = null
    //         }
    //     }
    // }

}
</script>

<style lang="less">
    .understanding-text-wrapper {
        .understanding-text-box {
            height: 100vh;
            overflow-y: scroll;
            .understanding-title {
                padding: 16px 0;
                text-align: center;
                font-size: 16px;
                color: rgba(0,0,0,.8);
            }
            .understanding-text {
                padding: 16px 16px 140px 16px;
            }
        }
        .page-ft {
            background-color: #fff;
            .doc-agree {
                padding: 10px 20px 0;
                .van-checkbox {
                    margin-bottom: 7px;
                    .van-checkbox__icon {
                        display: flex;
                        align-items: center;
                        .van-icon {
                            display: flex;
                            align-items: center;
                            height: 14px;
                            width: 14px;
                        }
                    }
                    .van-checkbox__label {
                        color: #000;
                        font-size: 14px;
                    }
                } 
                .tips {
                    padding-left: 24px;
                    font-size: 12px;
                    color: #636774;
                }
            }
        }
        .btn {
            margin-top: 0;
        }
    }
</style>